require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-mariasdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-mariasdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-mariasdorf!./.cache/json/betreuungseinrichtungen-oberwart-mariasdorf.json
// module id = 1012
// module chunks = 231608221292675